'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$24() {
  this.bg8 = null;
  this.bg6 = null;
  this.bg7 = false;
  this.bg4 = null;
  this.bg5 = false;
  this.bg9 = false;
  this.bga = false;
  this.bg8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$24 as $c_Lpresto_PrestoRouter$$anon$24 };
$p = $c_Lpresto_PrestoRouter$$anon$24.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$24;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$24() {
}
export { $h_Lpresto_PrestoRouter$$anon$24 as $h_Lpresto_PrestoRouter$$anon$24 };
$h_Lpresto_PrestoRouter$$anon$24.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bg8;
});
$p.t = (function() {
  if ((!this.bg7)) {
    this.bg6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bg7 = true;
  }
  return this.bg6;
});
$p.ae = (function() {
  if ((!this.bg5)) {
    this.bg4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bg5 = true;
  }
  return this.bg4;
});
$p.w = (function() {
  if ((!this.bga)) {
    this.bg9 = false;
    this.bga = true;
  }
  return this.bg9;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$24 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$24, "presto.PrestoRouter$$anon$24", ({
  NP: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$24 as $d_Lpresto_PrestoRouter$$anon$24 };
//# sourceMappingURL=presto.-Presto-Router$$anon$24.js.map
